module.exports = __webpack_public_path__ + "assets/img/Amaze-Wholesale-1-Landing-Page.46b27a1c.jpg";